import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  RecoilRoot,
} from 'recoil';
import Home from './components/Home';
import GameMain from './components/GameMain/GameMain';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Offline from './components/ErrorPage/Offline';
import GameOver from './components/GameOver';
import MyPage from './components/GameMain/MyPage/MyPage';
import { Page404 } from './components/Page404';
import TeacherPageCertification from './components/TeacherPageCertification';
import TeacherMyPage from './components/GameMain/TeacherMypage';
import TeacherGameMain from './components/GameMain/TeacherGameMain';
import CertificationPage from './components/Certification/CertificationPage';
import PrivacyPage from './components/PrivacyPolicy';
import Explain from './components/Slides/Explain/Explain';
import ItemExplain from './components/Slides/Item/ItemExplain';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const AppStyle = css`
    overflow-x: hidden;
    overflow-y: hidden;
    user-select: none;
    width: 100vw;
    height: 100vh;
  `;

  return (

    <div className="App" css={AppStyle}>

      {window.navigator.onLine ? (
        <>
          <RecoilRoot>
            <HelmetProvider>
              <BrowserRouter>
                <Routes>
                  <Route exact path="/" element={<Home />} />
                  <Route path="*" element={<Page404 />} />
                  <Route path="/gameover" element={<GameOver />} />
                  <Route path="/Explain" element={<Explain />} />
                  <Route path="/itemExplain" element={<ItemExplain />} />
                  <Route path="/my_page" element={<MyPage />} />
                  <Route path="/easy" element={<GameMain />} />
                  <Route path="/normal" element={<GameMain />} />
                  <Route path="/hard" element={<GameMain />} />
                  <Route path="/self" element={<GameMain />} />
                  <Route path="/teacher" element={<TeacherPageCertification />} />
                  <Route path="/teacher/my_page" element={<TeacherMyPage />} />
                  <Route path="/teacher/easy" element={< TeacherGameMain />} />
                  <Route path="/teacher/normal" element={<TeacherGameMain />} />
                  <Route path="/teacher/hard" element={<TeacherGameMain />} />
                  <Route path="/privacy_policy" element={<PrivacyPage />} />

                </Routes>
              </BrowserRouter>
            </HelmetProvider>
          </RecoilRoot>
        </>
      ) : (
        <>
          <Offline />
        </>
      )
      }
    </div>
  );
}

export default App;
